<template>
<div class="chapter">
<div class="inner_page">
<p class="copy">Publisher: Amy Marson</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Art Director/Cover Designer: Kristy Zacharias</p>
<p class="copy">Editor: Lynn Koolish</p>
<p class="copy">Technical Editors: Debbie Rodgers and Mary E. Flynn</p>
<p class="copy">Book Designer: Casey Dukes</p>
<p class="copy">Production Coordinator/Illustrator: Jenny Davis</p>
<p class="copy">Production Editor: Katie Van Amburg</p>
<p class="copy">Photo Assistant: Mary Peyton Peppo</p>
<p class="copy">Styled photos by Nissa Brehmer, unless otherwise noted; Instructional photos by Diane Pedersen, unless otherwise noted</p>
<p class="copy">Published by Stash Books, an imprint of C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_copyright.vue?1c3e2fd6